<template>
  <v-container id="Pagos-forms" fluid tag="section">
    <validation-observer v-slot="{ handleSubmit }">
      <form id="cobrosForm" @submit.prevent="handleSubmit(validateForm)">
        <v-card elevation="12">
          <v-tabs ref="tabs" v-model="internalValue" color="white" grow slider-size="100">
            <v-tabs-slider color="gold" />
            <v-tab v-for="(item, i) in tabs" :key="i" :ripple="false" :disabled="mode === 'precargado'">
              {{ item }}
            </v-tab>
            <v-tab-item>
              <!-- Derechos-->
              <calculo-derechos :precargado="{idJugador: idJugador, idContrato: idContrato, idDerecho: idDerecho}" :monedas="monedas" :mode="mode" :bloquear="bloquear" @montoGenerado="iniciarCobroDerecho" @reset="resetForm" />
              <!-- Derechos-->
            </v-tab-item>
            <v-tab-item class="pb-12">
              <calculo-extraordinarios :monedas="monedas" :bloquear="bloquear" @montoGenerado="iniciarCobroExtraordinario" @reset="resetForm" />
            </v-tab-item>
          </v-tabs>
        </v-card>
        <v-card class="v-card--material pa-3">
          <v-row>
            <v-col cols="3">
              <v-text-field v-model="totalSeleccionado" color="gold" type="number" step="0.01" :prefix="simboloMoneda" label="Total a pagar" disabled />
            </v-col>
            <v-col cols="3">
              <v-text-field v-model="totalRestante" color="gold" type="number" step="0.01" label="Saldo" :prefix="simboloMoneda" disabled />
            </v-col>
            <v-col cols="3">
              <v-select v-model="metodosDePagoSelected" color="gold" :items="metodosPago" label="Metodos de pago" return-object item-text="descripcion">
                <template v-slot:itemm="{ attrs, itemm, on }">
                  <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                    <v-list-item-content>
                      <v-list-item-title v-text="itemm.descripcion" />
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
            <v-spacer />
            <v-col cols="auto" class="pt-4">
              <v-btn color="gold" :disabled="registrarEnabled()" @click="registrarPago()">
                Agregar pago
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <datos-factura-recibo :datos-recibo="{ notas: dataForm.notas, obs: dataForm.obs, fecha: dataForm.fechaRecibo, documentacion_id: dataForm.docRecibo }"
                              :datos-factura="{ numero: dataForm.numeroFactura, fecha: dataForm.fechaFactura, documentacion_id: dataForm.docFactura }"
                              :mode="mode" @actualizarRecibo="actualizarRecibo" @actualizarFactura="actualizarFactura"
        />
        <v-card class="v-card--material pa-3">
          <v-card-title>Detalle recibo</v-card-title>
          <v-row justify="center">
            <v-col cols="12">
              <v-data-table v-if="dataForm.registroDePagos !== undefined" :headers="headers" :items="dataForm.registroDePagos" disable-sort>
                <template v-if="$can('M_jugadores_edita')" v-slot:[`item.actions`]="{ item }">
                  <v-tooltip content-class="top" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="anularPago(item)">
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
        <v-row justify="end">
          <v-col cols="auto">
            <v-btn :disabled="$disabled()" color="gold" class="mr-0" type="submit" form="cobrosForm">
              Grabar recibo
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <registro-pagos :show="dialogRegistrarPago" :total-restante="totalRestante" :title="metodosDePagoSelected.descripcion"
                    :metodo-pago="metodosDePagoSelected" :moneda="simboloMoneda" cobro
                    @pagoGenerado="agregarPago($event)" @closeDialog="dialogRegistrarPago = $event"
    />
  </v-container>
</template>

<script>
  import RegistroPagos from '../../../components/RegistroPagos.vue'
  import Vue from 'vue'
  import datosFacturaRecibo from '../../../components/FacturaReciboFiles'
  import CalculoDerechos from '../componentes/CalculoDerechos'
  import CalculoExtraordinarios from '../componentes/CalculoExtraordinarios.vue'

  export default {
    name: 'FormularioCobros',
    components: {
      RegistroPagos,
      datosFacturaRecibo,
      CalculoDerechos,
      CalculoExtraordinarios,
    },
    props: {
      idRecibo: {
        type: Number,
        default: 0,
      },
      mode: {
        type: String,
        default: '',
        required: false,
      },
      idJugador: {
        type: Number,
        default: 0,
      },
      idContrato: {
        type: Number,
        default: 0,
      },
      idDerecho: {
        type: Number,
        default: 0,
      },
    },
    data () {
      return {
        headers: [
          { text: 'Metodo de pago', align: 'start', value: 'metodopago.descripcion' },
          { text: 'Monto', value: 'montoACubrir' },
          { text: 'Deshacer', value: 'actions', sortable: false, align: 'end' },
        ],
        tabs: ['Jugador/Club', 'Cobro extraordinario'],
        internalValue: 0,
        metodosDePagoSelected: {},
        bloquear: false,
        dialogRegistrarPago: false,
        noVisible: 'visibility: hidden',
        monedas: [],
        totalRestante: 0,
        totalSeleccionado: 0,
        dataForm: {
          notas: '',
          obs: '',
          recibo: null,
          fechaRecibo: '',
          fechaFactura: '',
          docRecibo: null,
          docFactura: null,
          registroDePagos: [],
          registroDeCuotas: [],
          moneda_id: 1,
          club_id: null,
          jugador_id: null,
          numeroFactura: 0,
          tipo_factura_id: 0,
        },
        metodosPago: [],
        // preCargado: false,
      }
    },
    computed: {
      simboloMoneda () {
        return (this.monedas.length !== 0) ? this.monedas.find(e => e.id === this.dataForm.moneda_id).simbolo : '$'
      },
    },
    watch: {
      internalValue () {
        this.resetForm()
      },
    },
    created () {
      this.getMoneda()
      this.updateMetodosDePago()
    },
    methods: {
      resetForm () {
        this.totalRestante = 0
        this.totalSeleccionado = 0
        this.dataForm.moneda_id = 1
        this.dataForm.registroDeCuotas = []
        this.dataForm.registroDePagos = []
        this.dataForm.club_id = null
        this.dataForm.jugador_id = null
        this.bloquear = false
      },
      iniciarCobroExtraordinario (datos) {
        const monto = datos.totalAPagar
        this.totalRestante = monto
        this.totalSeleccionado = monto
        this.dataForm.contacto_id = datos.objetoPago
        this.dataForm.moneda_id = datos.monedaId
        this.dataForm.club_id = null
        this.dataForm.jugador_id = null
        this.dataForm.caso = 'extraordinario'
      },
      iniciarCobroDerecho (datos) {
        const monto = datos.monto
        this.totalRestante = monto
        this.totalSeleccionado = monto
        this.dataForm.moneda_id = datos.moneda_id
        this.dataForm.registroDeCuotas = datos.cuotasAPagar
        this.dataForm.club_id = datos.club_id
        this.dataForm.jugador_id = datos.jugador_id
        this.dataForm.caso = 'derechos'
      },
      actualizarRecibo (recibo) {
        this.dataForm.notas = recibo.notas
        this.dataForm.obs = recibo.obs
        this.dataForm.fechaRecibo = recibo.fecha
        this.dataForm.docRecibo = recibo.documentacion_id
      },
      actualizarFactura (factura) {
        this.dataForm.numeroFactura = factura.numeroFactura
        this.dataForm.fechaFactura = factura.fechaFactura
        this.dataForm.docFactura = factura.docFactura
        this.dataForm.tipo_factura_id = factura.tipo_factura_id
      },
      anularPago (pago) {
        this.totalRestante += pago.montoACubrir
        const index = this.dataForm.registroDePagos.indexOf(pago)
        if (index > -1) {
          this.dataForm.registroDePagos.splice(index, 1)
        }
      },
      registrarEnabled: function () {
        if (this.totalSeleccionado === 0.00 || this.metodosDePagoSelected === null ||
          Object.entries(this.metodosDePagoSelected).length === 0 || this.totalRestante === 0) {
          return true
        }
        return false
      },
      registrarPago () {
        this.bloquear = true
        this.dialogRegistrarPago = true
      },
      agregarPago (nuevoPago) {
        this.dialogRegistrarPago = false
        this.totalRestante -= nuevoPago.montoACubrir
        this.totalRestante = Math.round(this.totalRestante * 1e2) / 1e2
        const indexReg = this.dataForm.registroDePagos.length
        Vue.set(this.dataForm.registroDePagos, indexReg, nuevoPago)
      },
      agregarDocumentacionFactura (documento) {
        this.dataForm.docFactura = documento
      },
      updateMetodosDePago () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/metodo_pago/0' }).then(response => {
          this.metodosPago = response
        })
      },
      getMoneda () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/moneda' }).then(response => { this.monedas = response })
      },
      validateForm (scope) {
        if (this.totalRestante !== 0.00) {
          this.$store.commit('toast/show', { tipo: 'error', messages: ['Aún queda saldo restante'] })
        } else if (this.dataForm.registroDePagos.length === 0) {
          this.$store.commit('toast/show', { tipo: 'error', messages: ['Nada que aplicar'] })
        } else if (this.dataForm.numeroFactura === '') {
          this.$store.commit('toast/show', { tipo: 'error', messages: ['Debe ingresar un número de factura'] })
        } else {
          this.enviarPaquete()
        }
      },
      enviarPaquete: async function () {
        // const mode = (this.mode === 'new' || this.mode === 'precargado') ? 'postData' : 'putData'
        const mode = 'postData'
        await this.$store.dispatch('axiosMod/' + mode, { url: '/api/recibo', dataForm: this.dataForm })
          .then(response => {
            this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de cobro exitosa'] })
            this.$store.commit('dep/deleteCuotas')
            this.$router.push({ name: 'Listado de Recibos' })
              .catch(error => {
                if (error.response.data.errors) {
                  this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.errors] })
                } else if (error.response.data) {
                  this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
                } else {
                  this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
                }
              })
          })
        /* const method = 'post'
        await this.$http({
          method: method,
          url: '/api/recibo',
          data: {
            ...this.dataForm,
          },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de cobro exitosa'] })
          this.$store.commit('dep/deleteCuotas')
          this.$router.push({ name: 'Listado de Recibos' })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        }) */
      },
    },
  }
</script>

<style lang="sass">

  .v-card
    overflow: visible

    .v-tabs-bar
      height: 56px
      padding: 0 8px

    .v-tabs-slider
      border-radius: 4px

    .v-tabs-slider-wrapper
      overflow: visible

    .v-tabs-slider-wrapper
      contain: initial
      z-index: 0
</style>
